module.exports = __webpack_public_path__ + "img/KHACH_SAN.79e57f00.svg";